import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['fieldset']

  declare fieldsetTargets: HTMLFieldSetElement[]

  connect (): void {
    this.update()
  }

  update (): void {
    // Use setTimeout to ensure this runs after any changes to the fieldsets' visibility have been applied
    setTimeout(() => {
      this.fieldsetTargets.forEach((fieldset) => { fieldset.disabled = !fieldset.checkVisibility() })
    }, 0)
  }
}
